/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the AccountDeletionDto interface.
 */
export function instanceOfAccountDeletionDto(value) {
    let isInstance = true;
    return isInstance;
}
export function AccountDeletionDtoFromJSON(json) {
    return AccountDeletionDtoFromJSONTyped(json, false);
}
export function AccountDeletionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'deleteBefore': !exists(json, 'deleteBefore') ? undefined : (new Date(json['deleteBefore'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
    };
}
export function AccountDeletionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'subject': value.subject,
        'deleteBefore': value.deleteBefore === undefined ? undefined : (value.deleteBefore.toISOString()),
        'isDeleted': value.isDeleted,
    };
}
